export default __webpack_public_path__ + "static/media/money.60d328d8.svg";